import request from '@/utils/request'
import store from '@/store'

// 获取当前登录用户的 adminId
function getAdminId() {
  return store.state.userInfo?.id || store.state.userInfo?.adminId || JSON.parse(localStorage.getItem('userInfo') || '{}').id
}

// 获取奖项配置
export function getPrizeConfig() {
  return request({
    url: '/lottery/getPrizeConfig',
    method: 'post',
    data: {
      adminId: getAdminId()
    }
  })
}

// 设置奖项配置
export function setPrizeConfig(data) {
  return request({
    url: '/lottery/setPrizeConfig',
    method: 'post',
    data: {
      ...data,
      adminId: getAdminId()
    }
  })
}

// 获取中奖记录
export function getWinRecords(data) {
  return request({
    url: '/lottery/admin/winRecords',
    method: 'get',
    params: {
      adminId: getAdminId(),
      ...data
    }
  })
}

// 导出中奖记录
export function exportWinRecords(params) {
  return request({
    url: '/lottery/admin/winRecords/export',
    method: 'get',
    params: {
      adminId: getAdminId(),
      ...params
    },
    responseType: 'blob'
  })
}
